import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NgbCollapseModule,
  NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';
import { I18NextModule } from 'angular-i18next';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';

import { AutoFocusDirective } from './directives/auto-focus.directive';

import { EquipmentListComponent } from './components/equipment-list/equipment-list.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RequestDataComponent } from './components/request-data/request-data.component';
import { ReplacedDataComponent } from './components/replaced-data/replaced-data.component';
import { DeliveredVehicleComponent } from './components/delivered-vehicle/delivered-vehicle.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BookingVehicleDataComponent } from './components/booking-vehicle-data/booking-vehicle-data.component';
import { DriverDataComponent } from './components/driver-data/driver-data.component';
import { ProjectDataComponent } from './components/project-data/project-data.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ValueDataPipe } from './pipes/valueData.pipe';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NumberDataPipe } from './pipes/numberDate.pipe';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    I18NextModule,
    FontAwesomeModule,
    NgxSpinnerModule,
    NgbTooltipModule,
    NgxPaginationModule,
    NgbCollapseModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule
  ],
  declarations: [
    AutoFocusDirective,
    EquipmentListComponent,
    RequestDataComponent,
    ReplacedDataComponent,
    DeliveredVehicleComponent,
    BookingVehicleDataComponent,
    DriverDataComponent,
    ProjectDataComponent,
    ValueDataPipe,
    NumberDataPipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    I18NextModule,
    NgxSpinnerModule,
    NgbTooltipModule,
    FontAwesomeModule,
    EquipmentListComponent,
    MatButtonModule,
    MatDialogModule,
    NgxPaginationModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    RequestDataComponent,
    ReplacedDataComponent,
    DeliveredVehicleComponent,
    BookingVehicleDataComponent,
    DriverDataComponent,
    ProjectDataComponent,
    ValueDataPipe,
    NumberDataPipe
  ],
  providers: [DatePipe, NumberDataPipe]
})
export class SharedModule {}
